

































































import { Component, Vue, Prop } from 'vue-property-decorator';
import VueToastr from '@deveodk/vue-toastr';
import { vxm } from '@/store.vuex';
Vue.use(VueToastr, {
  defaultPosition: 'toast-top-right',
  defaultType: 'info',
  defaultTimeout: 5000,
});
import { ChangePhoneNumberRequest } from '../../models/userdata/changephonenumberrequest';

@Component({
  name: 'UpdatePhoneNumberNew',
  components: {},
})
export default class UpdatePhoneNumberNew extends Vue {
  @Prop() phone;
  @Prop({ default: '' }) countryCode;
  private newPhone: string = '';
  private newPhoneValid: boolean = false;
  private newPhoneNumber: string = '';
  
  $wlToastr: any;

  updateCandidatePhone(event) {
    console.log(
      'Number is :  ',
      '+' + event.countryCallingCode + ' ' + event.nationalNumber,
    );
    this.newPhoneNumber =
      '+' + event.countryCallingCode + ' ' + event.nationalNumber;
    this.newPhoneValid = event.isValid;
  }

  getCompanyCountryCode(): string {
    return vxm.jobs.getCompanyCountryCode;
  }

  get supportedCountries() {
    return vxm.utility.supportedCountries;
  }

  get defaultCountry() {
    return vxm.utility.defaultCountry;
  }

  async changePhoneNumber() {
    const vm = this;

    if (!this.newPhoneNumber) {
      vm.$wlToastr(
        'error',
        vm.$t('signup.phone.required'),
        vm.$t('UserProfile_MyProfile').toString(),
      );
      return;
    }

    if (!this.newPhoneValid) {
      vm.$wlToastr(
        'error',
        vm.$t('signup.phone.valid'),
        vm.$t('UserProfile_MyProfile').toString(),
      );
      return;
    }
    if (this.phone && this.phone === this.newPhoneNumber) {
      vm.$wlToastr(
        'error',
        vm.$t('signup.phone.duplicate'),
        vm.$t('UserProfile_MyProfile').toString(),
      );
      return;
    }

    var changePhoneNumberRequest = new ChangePhoneNumberRequest();
    changePhoneNumberRequest.newPhone = this.newPhoneNumber;
    const respPromise: any = vxm.users.changePhoneNumber(
      changePhoneNumberRequest,
    );
    const resp = await respPromise;
    if (resp.meta.success) {
      this.$modal.show('emailverificationcode-popup', {
        changePhoneNumberRequest: changePhoneNumberRequest,
        displayMessage: resp.meta.displayMessage,
      });
      this.$modal.hide('edit-phone');
    } else {
      vm.$wlToastr(
        'error',
        resp.data.errorMessage,
        vm.$t('UserProfile_MyProfile').toString(),
      );
    }
  }
}
